import React, { useEffect, useState } from "react"
import * as AppConstants from "../../utility/AppConstants"
import save from "save-file"
// REST
import axios from "axios"
// TAB
import TabNazionali from "../tab/nazionali/TabNazionali"
// CSS
// SPINNER
//import SpinnerModal from '../spinner/SpinnerModal';

import Breadcrumb from "../breadcrumb/Breadcrumb"
import { generaSVGGrafico } from "../../utility/Utility"
import NotaMetodologicaPDF from '../../../pdf/NTM_Internet_Singolo.pdf'

//import $ from 'jquery';
interface DatiNazionaliProps {
    anno: string
    codIsa?: string
    macroarea?: string
    tipologia?: string
}

function DatiNazionali(props: DatiNazionaliProps) {
    const [datiNazionali, setDatiNazionali] = useState([])
    const [macroareeTerritoriali, seMacroareeTerritoriali] = useState(null)

    const [respDatiNazionali, setRespDatiNazionali] = useState(false)
    const [respAreeTerritoriali, setRespAreeTerritoriali] = useState(false)

    useEffect(() => {
        const url = AppConstants.URL_GET_DATI_NAZIONALI
        const urlAreeTerritoriali = AppConstants.URL_GET_MACROAREE_TERRITORIALI
        const config = AppConstants.HEADER_CONFIG

        axios
            .get(url, {
                params: {
                    anno: props.anno,
                    codIsa: props.codIsa,
                    macroarea: props.macroarea
                },
                headers: config
            })
            .then((response) => {
                //console.log(response.data);
                setDatiNazionali(response.data)
                setRespDatiNazionali(true)
            })
            .catch((err) => {})

        if (props.codIsa !== null && props.codIsa !== undefined) {
            axios
                .get(urlAreeTerritoriali, {
                    params: {
                        anno: props.anno,
                        codIsa: props.codIsa,
                        macroarea: props.macroarea
                    },
                    headers: config
                })
                .then((response) => {
                    seMacroareeTerritoriali(response.data)
                    setRespAreeTerritoriali(true)
                })
                .catch((err) => {})
        } else {
            setRespAreeTerritoriali(true)
        }

        return () => {}
    }, [props.anno, props.codIsa, props.macroarea])

    function getTitle(props: Omit<DatiNazionaliProps, "anno">) {
        let title = "Dati Nazionali "
        if (props.codIsa !== null && props.codIsa !== undefined)
            title += "Codici ISA"
        else if (props.macroarea !== null && props.macroarea !== undefined)
            title += "Macrosettori"
        else title += "ISA"
        return title
    }

    let title = getTitle(props)

    return (
        <div className="main-min-vh" role="main">
            <div className="container-fluid py-3 py-md-4">
                {/*<SpinnerModal/>*/}

                <Breadcrumb voce={title} />

                <div className="row">
                    <div className="col">
                        <h1>
                            {title} - {props.anno}
                        </h1>
                    </div>

                    <div className="col">&nbsp;</div>

                    <div className="col-auto">
                        {respDatiNazionali && respAreeTerritoriali ? (
                            <a
                                rel="noopener noreferrer"
                                title="Download EXCEL Dati Nazionali"
                                href="downloadExcel"
                                onClick={(e) =>
                                    downloadExcelDatiNazionali(props, e)
                                }
                            >
                                <i className="fas fas fa-file-excel fa-3x mr-2"></i>
                            </a>
                        ) : (
                            <React.Fragment />
                        )}

                        {respDatiNazionali && respAreeTerritoriali ? (
                            <a
                                rel="noopener noreferrer"
                                title="Download PDF Dati Nazionali"
                                href="downloadPdf"
                                onClick={(e) =>
                                    downloadPDFDatiNazionali(props, e)
                                }
                            >
                                <i className="fas fas fa-file-pdf fa-3x mr-2"></i>
                            </a>
                        ) : (
                            <React.Fragment />
                        )}
                    </div>

                    <div className="col-auto">
                        <a
                            href={NotaMetodologicaPDF
                                // process.env.CONTEXT_PATH +
                                // "/public/resources/pdf/Nota_Metodologica.pdf"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Nota Metodologica"
                        >
                            <span className="fas fa-info-circle fa-3x mr-2"></span>
                        </a>
                    </div>
                </div>
                {respDatiNazionali && respAreeTerritoriali ? (
                    <TabNazionali
                        datiNazionali={datiNazionali}
                        codIsa={props.codIsa}
                        macroarea={props.macroarea}
                        macroareeTerritoriali={macroareeTerritoriali}
                        anno={props.anno}
                    />
                ) : (
                    <React.Fragment />
                )}
            </div>
        </div>
    )
}

function downloadExcelDatiNazionali(
    props: DatiNazionaliProps,
    e: React.MouseEvent<any>
) {
    e.preventDefault()
    let nomeExcel = `datiNazionali_${props.anno}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    //$("#apri").click();

    if (codIsa !== null && codIsa !== undefined) {
        nomeExcel += "_" + codIsa + ".xlsx"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomeExcel += "_" + macroarea + ".xlsx"
    } else {
        nomeExcel += ".xlsx"
    }

    const config = AppConstants.HEADER_CONFIG
    const formData = new FormData()
    formData.append("anno", props.anno)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "filePie",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("pie_chart") as Node
            )
        )
    )
    formData.append(
        "fileBar",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("bar_chart") as Node
            )
        )
    )

    //console.log((new XMLSerializer).serializeToString(document.getElementById('bar_chart')));

    axios
        .post(AppConstants.URL_GET_EXCEL_DATI_NAZIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let excelByte = response.data.excel
            save(excelByte, nomeExcel)
            //test(excelByte, nomeExcel);
            //console.log(excelByte);
        })
        .catch((err) => {
            //$("#chiudi").click();
        })
}

/*
async function test(excelByte, nomeExcel){
    await save(excelByte, nomeExcel);
    $("#chiudi").click();
    console.log("chiudi");
}
*/

function downloadPDFDatiNazionali(
    props: DatiNazionaliProps,
    e: React.MouseEvent<any>
) {
    e.preventDefault()
    let nomePDF = `datiNazionali_${props.anno}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    //$("#apri").click();

    if (codIsa !== null && codIsa !== undefined) {
        nomePDF += "_" + codIsa + ".pdf"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomePDF += "_" + macroarea + ".pdf"
    } else {
        nomePDF += ".pdf"
    }

    const config = AppConstants.HEADER_CONFIG
    const formData = new FormData()
    formData.append("anno", props.anno)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "filePie",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("pie_chart") as Node
            )
        )
    )
    formData.append(
        "fileBar",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("bar_chart") as Node
            )
        )
    )

    //console.log(props.anno,macroarea,codIsa);
    axios
        .post(AppConstants.URL_GET_PDF_DATI_NAZIONALI_V2, formData, {
            headers: config
        })
        .then( (response) => {
            let pdfByte = response.data.pdf
            //  let blob = new Blob([pdfByte], {type: "application/pdf;base64"});
            //  let url = URL.createObjectURL(blob);
            //  window.location.href = url;
              save(pdfByte, nomePDF)
            //$("#chiudi").click();
        })
        .catch((err) => {
            //$("#chiudi").click();
        })
}

export default DatiNazionali
